import type { Question } from '@mentimeter/legacy-series-types/question';
import type { Slide as VotingSlide } from '../../compatibility-overrides/voting-types';
import type { CompatibilitySlide } from '../../compatibility-types';
import { imagePositionToQuestionSlideImageType } from '../converters/static-content';
import type { CommonQuestionProperty } from './get-common-question-property';

export const getQuestionImageProperty = (
  target: CompatibilitySlide<'image'> | VotingSlide<'image'>,
  prop: keyof Question,
) => {
  const staticContents = target.staticContent;

  switch (prop as keyof Omit<Question, CommonQuestionProperty>) {
    case 'question':
      return staticContents.caption;
    case 'slide_image_type':
      return imagePositionToQuestionSlideImageType(
        staticContents.imagePosition,
      );
    case 'sub_type':
      return 'image';
    case 'question_styled':
      return staticContents.styledTitle ?? {};
    default:
      return undefined;
  }
};
